import { useTranslation } from 'react-i18next';
import termsHtmlByLocale from '../../assets/terms-and-conditions/terms-html.json';

export const TRAVELLER_TERMS_I18N_KEY = 'traveller_terms_sections';

export const useTravellerTermsHtml = (): string | null => {
  const { i18n, t } = useTranslation();
  const html = termsHtmlByLocale[i18n.language as keyof typeof termsHtmlByLocale];

  if (html) {
    return html;
  }

  const translatedSections = t(TRAVELLER_TERMS_I18N_KEY, {
    returnObjects: true
  }) as unknown;

  if (Array.isArray(translatedSections)) {
    return translatedSections.join('');
  }

  return termsHtmlByLocale['en-GB'];
};
